import { render, staticRenderFns } from "./cpt-dataV-scrollList.vue?vue&type=template&id=2fd85b40&scoped=true"
import script from "./cpt-dataV-scrollList.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-scrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd85b40",
  null
  
)

export default component.exports